// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   RiCloseLine,
//   RiCheckLine,
//   RiErrorWarningLine,
//   RiCalendarLine,
//   RiFileList3Line,
//   RiUserLine,
//   RiArrowDownSLine,
//   RiMegaphoneLine,
//   RiPaletteLine,
//   RiUserStarLine,
//   RiPriceTag3Line,
//   RiRulerLine,
//   RiFolderLine,
//   RiMoneyDollarCircleLine,
//   RiGroupLine,
//   RiLockLine,
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";

// const BASE_URL = process.env.REACT_APP_API_URL;

// const Spinner = ({ className = "w-4 h-4" }) => (
//   <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
// );

// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3500);
//     return () => clearTimeout(t);
//   }, [onClose]);
//   return (
//     <div
//       className={`fixed top-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
//       ${
//         type === "success"
//           ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
//           : "bg-red-50 border border-red-200 text-red-800"
//       }`}
//     >
//       {type === "success" ? (
//         <RiCheckLine className="w-4 h-4 text-emerald-500" />
//       ) : (
//         <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       )}
//       <span>{message}</span>
//       <button
//         onClick={onClose}
//         className="ml-2 opacity-50 hover:opacity-100 transition"
//       >
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// const Label = ({ children, required = false }) => (
//   <label className="text-[10px] font-semibold text-blue-600 uppercase tracking-widest mb-1 block">
//     {children}
//     {required && <span className="text-red-500 ml-1">*</span>}
//   </label>
// );

// const inputCls =
//   "w-full bg-blue-50/60 border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition";

// const selectCls =
//   "w-full bg-[#3d2626] border border-[#3d2626] rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-blue-500/30 transition appearance-none cursor-pointer";

// const SelectWrapper = ({ children }) => (
//   <div className="relative">
//     {children}
//     <RiArrowDownSLine className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white pointer-events-none" />
//   </div>
// );

// const tomorrow = () => {
//   const d = new Date();
//   d.setDate(d.getDate());
//   return d.toISOString().split("T")[0];
// };

// const defaultForm = {
//   quotationType: "advertising",
//   quotationCategory: "",
//   personName: "",
//   advertisingType: "",
//   size: { height: "", width: "" },
//   mediaRateCardItems: [],
//   brandingPricing: {
//     type1Price: "",
//     type2Price: "",
//     type3Price: "",
//     numberOfPersons: "",
//   },
//   client: "",
//   referral: "",
//   date: tomorrow(),
// };

// export default function Quotation() {
//   const [form, setForm] = useState(defaultForm);

//   const [clients, setClients] = useState([]);
//   const [agents, setAgents] = useState([]);
//   const [globalAdvTypes, setGlobalAdvTypes] = useState([]);
//   const [quotationCategories, setQuotationCategories] = useState([]);
//   const [rateCards, setRateCards] = useState([]);
//   const [rateCardsLoading, setRateCardsLoading] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [toast, setToast] = useState(null);
//   const [createdNumber, setCreatedNumber] = useState(null);

//   const notify = (msg, type = "success") => setToast({ message: msg, type });

//   // Initial data load
//   useEffect(() => {
//     const load = async () => {
//       setLoading(true);
//       try {
//         const [cR, aR, atR, catR] = await Promise.allSettled([
//           axios.get(`${BASE_URL}/bank/get-banks`),
//           axios.get(`${BASE_URL}/agent/all-agents`),
//           axios.get(`${BASE_URL}/quotation-advertising-type`),
//           axios.get(`${BASE_URL}/quotation-category`),
//         ]);
//         if (cR.status === "fulfilled")
//           setClients(cR.value?.data?.data || cR.value.data || []);
//         if (aR.status === "fulfilled")
//           setAgents(aR.value?.data?.data || aR.value.data || []);
//         if (atR.status === "fulfilled")
//           setGlobalAdvTypes(atR.value?.data?.data || atR.value.data || []);
//         if (catR.status === "fulfilled")
//           setQuotationCategories(
//             catR.value?.data?.data || catR.value.data || [],
//           );
//       } catch {
//         notify("Some data failed to load", "error");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, []);

//   // Fetch rate cards when advertisingType changes
//   useEffect(() => {
//     if (!form.advertisingType || form.quotationType !== "advertising") {
//       setRateCards([]);
//       setField("mediaRateCardItems", []);
//       return;
//     }

//     const fetchRateCards = async () => {
//       setRateCardsLoading(true);
//       setField("mediaRateCardItems", []);
//       try {
//         const res = await axios.get(
//           `${BASE_URL}/media-rate/by-advertising-type/${form.advertisingType}`,
//         );
//         setRateCards(res.data?.data || []);
//       } catch {
//         notify("Failed to load rate cards", "error");
//         setRateCards([]);
//       } finally {
//         setRateCardsLoading(false);
//       }
//     };

//     fetchRateCards();
//   }, [form.advertisingType, form.quotationType]);

//   // Sync global size into all selected mediaRateCardItems whenever size changes
//   useEffect(() => {
//     if (!form.mediaRateCardItems.length) return;
//     const h = parseFloat(form.size.height);
//     const w = parseFloat(form.size.width);
//     if (!h && !w) return;
//     setForm((f) => ({
//       ...f,
//       mediaRateCardItems: f.mediaRateCardItems.map((item) => ({
//         ...item,
//         ...(h > 0 ? { height: h } : {}),
//         ...(w > 0 ? { width: w } : {}),
//       })),
//     }));
//   }, [form.size.height, form.size.width]);

//   const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

//   const setSizeField = (field, value) => {
//     setForm((f) => ({
//       ...f,
//       size: { ...f.size, [field]: value },
//     }));
//   };

//   const setBrandingField = (field, value) => {
//     setForm((f) => ({
//       ...f,
//       brandingPricing: {
//         ...f.brandingPricing,
//         [field]: value,
//       },
//     }));
//   };

//   // Toggle rate card — seeds dimensions from global size fields
//   const handleRateCardToggle = (rateCard) => {
//     const existingIndex = form.mediaRateCardItems.findIndex(
//       (item) => item.mediaRateCard === rateCard._id,
//     );

//     if (existingIndex !== -1) {
//       setField(
//         "mediaRateCardItems",
//         form.mediaRateCardItems.filter((_, idx) => idx !== existingIndex),
//       );
//     } else {
//       const h = parseFloat(form.size.height) || 1;
//       const w = parseFloat(form.size.width) || 1;
//       setField("mediaRateCardItems", [
//         ...form.mediaRateCardItems,
//         {
//           mediaRateCard: rateCard._id,
//           height: h,
//           width: w,
//         },
//       ]);
//     }
//   };

//   const getRateCardById = (id) => rateCards.find((rc) => rc._id === id);

//   const calculatePreview = (height, width, ratePerSquareMeter) => {
//     const area = height * width;
//     const amount = area * ratePerSquareMeter;
//     return { area, amount };
//   };

//   const isSelected = (rateCardId) =>
//     form.mediaRateCardItems.some((item) => item.mediaRateCard === rateCardId);

//   const getSelectedItem = (rateCardId) =>
//     form.mediaRateCardItems.find((item) => item.mediaRateCard === rateCardId);

//   const handleSelectAll = () => {
//     if (form.mediaRateCardItems.length === rateCards.length) {
//       setField("mediaRateCardItems", []);
//     } else {
//       const h = parseFloat(form.size.height) || 1;
//       const w = parseFloat(form.size.width) || 1;
//       const allItems = rateCards.map((rc) => ({
//         mediaRateCard: rc._id,
//         height: h,
//         width: w,
//       }));
//       setField("mediaRateCardItems", allItems);
//     }
//   };

//   const calculateTotalAmount = () => {
//     let total = 0;
//     form.mediaRateCardItems.forEach((item) => {
//       const rateCard = getRateCardById(item.mediaRateCard);
//       if (rateCard) {
//         const area = item.height * item.width;
//         total += area * rateCard.ratePerSquareMeter;
//       }
//     });
//     return total;
//   };

//   const calculateBrandingTotal = () => {
//     const { type1Price, type2Price, type3Price, numberOfPersons } =
//       form.brandingPricing;
//     if (type1Price && type2Price && type3Price && numberOfPersons) {
//       return (
//         (parseFloat(type1Price) +
//           parseFloat(type2Price) +
//           parseFloat(type3Price)) *
//         parseFloat(numberOfPersons)
//       );
//     }
//     return 0;
//   };

//   const handleSubmit = async () => {
//     if (!form.client) return notify("Please select a client", "error");

//     if (form.quotationType === "advertising") {
//       if (!form.personName.trim())
//         return notify(
//           "Person name is required for advertising quotation",
//           "error",
//         );
//       if (!form.advertisingType)
//         return notify(
//           "Advertising type is required for advertising quotation",
//           "error",
//         );

//       const h = parseFloat(form.size.height);
//       const w = parseFloat(form.size.width);
//       if (!h || h <= 0)
//         return notify(
//           "Valid height is required for advertising quotation",
//           "error",
//         );
//       if (!w || w <= 0)
//         return notify(
//           "Valid width is required for advertising quotation",
//           "error",
//         );

//       if (!form.mediaRateCardItems.length)
//         return notify(
//           "At least one media rate card is required for advertising quotation",
//           "error",
//         );
//     } else if (form.quotationType === "branding") {
//       const { type1Price, type2Price, type3Price, numberOfPersons } =
//         form.brandingPricing;
//       if (!type1Price || parseFloat(type1Price) <= 0)
//         return notify(
//           "Valid Type 1 price is required for branding quotation",
//           "error",
//         );
//       if (!type2Price || parseFloat(type2Price) <= 0)
//         return notify(
//           "Valid Type 2 price is required for branding quotation",
//           "error",
//         );
//       if (!type3Price || parseFloat(type3Price) <= 0)
//         return notify(
//           "Valid Type 3 price is required for branding quotation",
//           "error",
//         );
//       if (!numberOfPersons || parseInt(numberOfPersons) <= 0)
//         return notify(
//           "Valid number of persons is required for branding quotation",
//           "error",
//         );
//     }

//     setSubmitting(true);
//     try {
//       const payload = {
//         quotationType: form.quotationType,
//         client: form.client,
//         date: form.date,
//       };

//       if (form.quotationType === "advertising" && form.quotationCategory) {
//         payload.quotationCategory = form.quotationCategory;
//       }

//       if (form.quotationType === "advertising") {
//         payload.personName = form.personName;
//         payload.advertisingType = form.advertisingType;
//         payload.mediaRateCardItems = form.mediaRateCardItems;
//       } else if (form.quotationType === "branding") {
//         payload.brandingPricing = {
//           type1Price: parseFloat(form.brandingPricing.type1Price),
//           type2Price: parseFloat(form.brandingPricing.type2Price),
//           type3Price: parseFloat(form.brandingPricing.type3Price),
//           numberOfPersons: parseInt(form.brandingPricing.numberOfPersons),
//         };
//       }

//       if (form.referral) payload.referral = form.referral;

//       const res = await axios.post(`${BASE_URL}/quotation/create`, payload);
//       setCreatedNumber(res.data?.data?.quotationNumber || "New");
//       notify("Quotation created successfully!");
//       setForm(defaultForm);
//       setRateCards([]);
//     } catch (err) {
//       notify(
//         err.response?.data?.message || "Failed to create quotation",
//         "error",
//       );
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-slate-50 text-slate-800">
//       {/* Header */}
//       <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4">
//           <div className="flex items-center gap-3">
//             <div className="w-10 h-10 rounded-xl bg-indigo-600 flex items-center justify-center text-white shadow-md shadow-indigo-200">
//               <RiFileList3Line className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-slate-800 tracking-tight">
//                 Create Quotation
//               </h1>
//               <p className="text-[11px] text-blue-400 tracking-widest uppercase">
//                 New Quotation
//               </p>
//             </div>
//           </div>
//           <div className="flex items-center gap-3">
//             {loading && (
//               <span className="flex items-center gap-2 text-xs text-blue-400">
//                 <Spinner /> Loading…
//               </span>
//             )}
//             {createdNumber && (
//               <div className="flex items-center gap-2 px-3 py-1.5 bg-emerald-50 border border-emerald-200 rounded-xl">
//                 <RiCheckLine className="w-3.5 h-3.5 text-emerald-500" />
//                 <span className="text-xs font-semibold text-emerald-700">
//                   {createdNumber} Created
//                 </span>
//               </div>
//             )}
//           </div>
//         </div>
//       </header>

//       <div className="px-6 py-6 pb-16 space-y-5 w-full mx-auto">
//         {/* Quotation Details */}
//         <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
//           <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50">
//             <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//               Quotation Details
//             </span>
//           </div>

//           <div className="p-5 grid grid-cols-2 gap-5 sm:grid-cols-3">
//             {/* Quotation Type */}
//             <div className="col-span-2 sm:col-span-1">
//               <Label>Quotation Type</Label>
//               <div className="flex gap-2">
//                 {[
//                   {
//                     value: "advertising",
//                     label: "Advertising",
//                     Icon: RiMegaphoneLine,
//                   },
//                   { value: "branding", label: "Branding", Icon: RiPaletteLine },
//                 ].map(({ value, label, Icon }) => (
//                   <button
//                     key={value}
//                     type="button"
//                     onClick={() => {
//                       setForm((f) => ({
//                         ...f,
//                         quotationType: value,
//                         quotationCategory: "",
//                         size: { height: "", width: "" },
//                         ...(value === "branding" && {
//                           personName: "",
//                           advertisingType: "",
//                           mediaRateCardItems: [],
//                         }),
//                         ...(value === "advertising" && {
//                           brandingPricing: {
//                             type1Price: "",
//                             type2Price: "",
//                             type3Price: "",
//                             numberOfPersons: "",
//                           },
//                         }),
//                       }));
//                       if (value === "branding") setRateCards([]);
//                     }}
//                     className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition
//                       ${
//                         form.quotationType === value
//                           ? "bg-indigo-600 border-indigo-600 text-white shadow-sm"
//                           : "bg-blue-50 border-blue-200 text-blue-500 hover:bg-blue-100"
//                       }`}
//                   >
//                     <Icon className="w-3.5 h-3.5" />
//                     {label}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Quotation Category - Advertising only */}
//             {form.quotationType === "advertising" && (
//               <div>
//                 <Label>
//                   <RiFolderLine className="inline w-3 h-3 mr-1" />
//                   Quotation Category
//                 </Label>
//                 <SelectWrapper>
//                   <select
//                     value={form.quotationCategory}
//                     onChange={(e) =>
//                       setField("quotationCategory", e.target.value)
//                     }
//                     className={selectCls}
//                   >
//                     <option value="">-- Select Category --</option>
//                     {quotationCategories.map((cat) => (
//                       <option key={cat._id} value={cat._id}>
//                         {cat.name}
//                       </option>
//                     ))}
//                   </select>
//                 </SelectWrapper>
//               </div>
//             )}

//             {/* Client */}
//             <div>
//               <Label required>Client</Label>
//               <SelectWrapper>
//                 <select
//                   value={form.client}
//                   onChange={(e) => setField("client", e.target.value)}
//                   className={selectCls}
//                 >
//                   <option value="">-- Select Client --</option>
//                   {clients.map((c) => (
//                     <option key={c._id} value={c._id}>
//                       {c.bankName || c.name}
//                     </option>
//                   ))}
//                 </select>
//               </SelectWrapper>
//             </div>

//             {/* Date */}
//             <div>
//               <Label>Date</Label>
//               <div className="relative">
//                 <RiCalendarLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
//                 <input
//                   type="date"
//                   value={form.date}
//                   onChange={(e) => setField("date", e.target.value)}
//                   className={`${inputCls} pl-9`}
//                 />
//               </div>
//             </div>

//             {/* Person Name - Advertising only */}
//             {form.quotationType === "advertising" && (
//               <div>
//                 <Label required>Person Name</Label>
//                 <div className="relative">
//                   <RiUserLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
//                   <input
//                     type="text"
//                     value={form.personName}
//                     onChange={(e) => setField("personName", e.target.value)}
//                     placeholder="Enter person name"
//                     className={`${inputCls} pl-9`}
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Advertising Type - Advertising only */}
//             {form.quotationType === "advertising" && (
//               <div>
//                 <Label required>
//                   <RiPriceTag3Line className="inline w-3 h-3 mr-1" />
//                   Advertising Type
//                 </Label>
//                 <SelectWrapper>
//                   <select
//                     value={form.advertisingType}
//                     onChange={(e) =>
//                       setField("advertisingType", e.target.value)
//                     }
//                     className={selectCls}
//                   >
//                     <option value="">-- Select Type --</option>
//                     {globalAdvTypes.map((at) => (
//                       <option key={at._id} value={at._id}>
//                         {at.name}
//                       </option>
//                     ))}
//                   </select>
//                 </SelectWrapper>
//               </div>
//             )}

//             {/* Global Size Fields - Advertising only */}
//             {form.quotationType === "advertising" && (
//               <>
//                 <div>
//                   <Label required>
//                     <RiRulerLine className="inline w-3 h-3 mr-1" />
//                     Height (m)
//                   </Label>
//                   <div className="relative">
//                     <RiRulerLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
//                     <input
//                       type="number"
//                       step="0.01"
//                       min="0.01"
//                       value={form.size.height}
//                       onChange={(e) => setSizeField("height", e.target.value)}
//                       placeholder="Enter height in meters"
//                       className={`${inputCls} pl-9`}
//                     />
//                   </div>
//                   <p className="text-xs text-slate-400 mt-1">
//                     Applied to all rate cards
//                   </p>
//                 </div>

//                 <div>
//                   <Label required>
//                     <RiRulerLine className="inline w-3 h-3 mr-1" />
//                     Width (m)
//                   </Label>
//                   <div className="relative">
//                     <RiRulerLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
//                     <input
//                       type="number"
//                       step="0.01"
//                       min="0.01"
//                       value={form.size.width}
//                       onChange={(e) => setSizeField("width", e.target.value)}
//                       placeholder="Enter width in meters"
//                       className={`${inputCls} pl-9`}
//                     />
//                   </div>
//                   <p className="text-xs text-slate-400 mt-1">
//                     Applied to all rate cards
//                   </p>
//                 </div>
//               </>
//             )}

//             {/* Referral */}
//             <div>
//               <Label>
//                 <RiUserStarLine className="inline w-3 h-3 mr-1" />
//                 Referral (Agent)
//               </Label>
//               <SelectWrapper>
//                 <select
//                   value={form.referral}
//                   onChange={(e) => setField("referral", e.target.value)}
//                   className={selectCls}
//                 >
//                   <option value="">-- Select Agent --</option>
//                   {agents.map((a) => (
//                     <option key={a._id} value={a._id}>
//                       {a.name}
//                     </option>
//                   ))}
//                 </select>
//               </SelectWrapper>
//             </div>
//           </div>
//         </div>

//         {/* Branding Pricing Section */}
//         {form.quotationType === "branding" && (
//           <div className="bg-white border border-purple-100 rounded-2xl shadow-sm overflow-hidden">
//             <div className="px-5 py-3 border-b border-purple-50 bg-purple-50/50">
//               <span className="text-xs font-semibold text-purple-700 uppercase tracking-widest">
//                 Branding Pricing Details
//               </span>
//             </div>

//             <div className="p-5">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                 <div>
//                   <Label required>
//                     <RiMoneyDollarCircleLine className="inline w-3 h-3 mr-1" />
//                     Type 1 Price (₹)
//                   </Label>
//                   <input
//                     type="number"
//                     step="0.01"
//                     min="0"
//                     value={form.brandingPricing.type1Price}
//                     onChange={(e) =>
//                       setBrandingField("type1Price", e.target.value)
//                     }
//                     placeholder="Enter Type 1 price"
//                     className={inputCls}
//                   />
//                   <p className="text-xs text-slate-400 mt-1">
//                     Base price for Type 1 branding
//                   </p>
//                 </div>

//                 <div>
//                   <Label required>
//                     <RiMoneyDollarCircleLine className="inline w-3 h-3 mr-1" />
//                     Type 2 Price (₹)
//                   </Label>
//                   <input
//                     type="number"
//                     step="0.01"
//                     min="0"
//                     value={form.brandingPricing.type2Price}
//                     onChange={(e) =>
//                       setBrandingField("type2Price", e.target.value)
//                     }
//                     placeholder="Enter Type 2 price"
//                     className={inputCls}
//                   />
//                   <p className="text-xs text-slate-400 mt-1">
//                     Base price for Type 2 branding
//                   </p>
//                 </div>

//                 <div>
//                   <Label required>
//                     <RiMoneyDollarCircleLine className="inline w-3 h-3 mr-1" />
//                     Type 3 Price (₹)
//                   </Label>
//                   <input
//                     type="number"
//                     step="0.01"
//                     min="0"
//                     value={form.brandingPricing.type3Price}
//                     onChange={(e) =>
//                       setBrandingField("type3Price", e.target.value)
//                     }
//                     placeholder="Enter Type 3 price"
//                     className={inputCls}
//                   />
//                   <p className="text-xs text-slate-400 mt-1">
//                     Base price for Type 3 branding
//                   </p>
//                 </div>

//                 <div>
//                   <Label required>
//                     <RiGroupLine className="inline w-3 h-3 mr-1" />
//                     Number of Persons
//                   </Label>
//                   <input
//                     type="number"
//                     step="1"
//                     min="1"
//                     value={form.brandingPricing.numberOfPersons}
//                     onChange={(e) =>
//                       setBrandingField("numberOfPersons", e.target.value)
//                     }
//                     placeholder="Enter number of persons"
//                     className={inputCls}
//                   />
//                   <p className="text-xs text-slate-400 mt-1">
//                     Total number of persons for branding
//                   </p>
//                 </div>
//               </div>

//               {calculateBrandingTotal() > 0 && (
//                 <div className="mt-5 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl border border-purple-100">
//                   <div className="flex justify-between items-center">
//                     <div>
//                       <span className="text-xs font-semibold text-purple-600 uppercase tracking-wider">
//                         Total Amount Preview
//                       </span>
//                       <p className="text-xs text-slate-500 mt-1">
//                         ({form.brandingPricing.type1Price} +{" "}
//                         {form.brandingPricing.type2Price} +{" "}
//                         {form.brandingPricing.type3Price}) ×{" "}
//                         {form.brandingPricing.numberOfPersons}
//                       </p>
//                     </div>
//                     <span className="text-2xl font-bold text-purple-600">
//                       ₹
//                       {calculateBrandingTotal().toLocaleString("en-IN", {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       })}
//                     </span>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {/* Media Rate Cards Section - Advertising only */}
//         {form.quotationType === "advertising" && form.advertisingType && (
//           <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
//             <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
//               <div className="flex items-center gap-3">
//                 <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                   Media Rate Cards
//                 </span>
//                 {/* Live size badge */}
//                 {(form.size.height || form.size.width) && (
//                   <span className="flex items-center gap-1 px-2 py-0.5 bg-indigo-50 border border-indigo-200 rounded-full text-[10px] font-semibold text-indigo-600">
//                     <RiRulerLine className="w-3 h-3" />
//                     {form.size.height || "–"} × {form.size.width || "–"} m
//                   </span>
//                 )}
//               </div>
//               {rateCards.length > 0 && (
//                 <button
//                   onClick={handleSelectAll}
//                   className="text-xs font-medium text-indigo-600 hover:text-indigo-700 px-3 py-1 rounded-lg hover:bg-indigo-50 transition"
//                 >
//                   {form.mediaRateCardItems.length === rateCards.length
//                     ? "Deselect All"
//                     : "Select All"}
//                 </button>
//               )}
//             </div>

//             <div className="p-5">
//               {/* Hint when size not filled */}
//               {(!form.size.height || !form.size.width) && (
//                 <div className="mb-4 flex items-center gap-2 px-4 py-2.5 bg-amber-50 border border-amber-200 rounded-xl text-xs text-amber-700 font-medium">
//                   <RiRulerLine className="w-4 h-4 flex-shrink-0" />
//                   Enter Height &amp; Width above — dimensions will auto-fill for
//                   all rate cards.
//                 </div>
//               )}

//               {rateCardsLoading ? (
//                 <div className="flex items-center justify-center py-8">
//                   <Spinner className="w-6 h-6 text-blue-400" />
//                   <span className="ml-2 text-sm text-blue-500">
//                     Loading rate cards...
//                   </span>
//                 </div>
//               ) : rateCards.length === 0 ? (
//                 <div className="text-center py-8 text-slate-400 text-sm">
//                   No rate cards available for this advertising type
//                 </div>
//               ) : (
//                 <div className="space-y-4 max-h-96 overflow-y-auto pr-2">
//                   {rateCards.map((rc) => {
//                     const selected = isSelected(rc._id);
//                     const selectedItem = getSelectedItem(rc._id);
//                     const { area, amount } =
//                       selected && selectedItem
//                         ? calculatePreview(
//                             selectedItem.height,
//                             selectedItem.width,
//                             rc.ratePerSquareMeter,
//                           )
//                         : { area: 0, amount: 0 };

//                     return (
//                       <div
//                         key={rc._id}
//                         className={`border rounded-lg transition ${
//                           selected
//                             ? "border-indigo-300 bg-indigo-50/30"
//                             : "border-blue-100 hover:bg-blue-50/50"
//                         }`}
//                       >
//                         {/* Rate Card Header */}
//                         <div className="p-3">
//                           <label className="flex items-start gap-3 cursor-pointer">
//                             <input
//                               type="checkbox"
//                               checked={selected}
//                               onChange={() => handleRateCardToggle(rc)}
//                               className="mt-0.5 w-4 h-4 text-indigo-600 rounded border-blue-300 focus:ring-indigo-500"
//                             />
//                             <div className="flex-1">
//                               <div className="flex items-center gap-2 mb-1">
//                                 <span className="font-semibold text-sm text-slate-800">
//                                   {rc.media?.organisation ?? "Unknown Media"}
//                                 </span>
//                                 <span className="text-xs text-blue-500 bg-blue-100 px-2 py-0.5 rounded">
//                                   {rc.edition}
//                                 </span>
//                                 <span className="text-xs font-mono text-slate-500">
//                                   Rate: ₹
//                                   {rc.ratePerSquareMeter?.toLocaleString(
//                                     "en-IN",
//                                   )}
//                                   /sqm
//                                 </span>
//                               </div>
//                               {rc.description && (
//                                 <p className="text-xs text-slate-400 mt-1">
//                                   {rc.description}
//                                 </p>
//                               )}
//                             </div>
//                           </label>
//                         </div>

//                         {/* Read-only dimension display (shown only when selected) */}
//                         {selected && selectedItem && (
//                           <div className="px-3 pb-3 pt-0 border-t border-indigo-100 mt-2">
//                             <div className="grid grid-cols-2 gap-3 pt-3">
//                               {/* Height - read only */}
//                               <div>
//                                 <label className="text-[10px] font-semibold text-indigo-600 uppercase tracking-wider flex items-center gap-1">
//                                   Height (m)
//                                   <RiLockLine className="w-3 h-3 text-indigo-400" />
//                                 </label>
//                                 <div className="relative mt-1">
//                                   <RiRulerLine className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-indigo-300" />
//                                   <input
//                                     type="number"
//                                     readOnly
//                                     tabIndex={-1}
//                                     value={selectedItem.height}
//                                     className="w-full pl-8 pr-3 py-1.5 text-sm border border-indigo-100 rounded-lg bg-slate-50 text-slate-400 cursor-not-allowed focus:outline-none"
//                                   />
//                                 </div>
//                               </div>
//                               {/* Width - read only */}
//                               <div>
//                                 <label className="text-[10px] font-semibold text-indigo-600 uppercase tracking-wider flex items-center gap-1">
//                                   Width (m)
//                                   <RiLockLine className="w-3 h-3 text-indigo-400" />
//                                 </label>
//                                 <div className="relative mt-1">
//                                   <RiRulerLine className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-indigo-300" />
//                                   <input
//                                     type="number"
//                                     readOnly
//                                     tabIndex={-1}
//                                     value={selectedItem.width}
//                                     className="w-full pl-8 pr-3 py-1.5 text-sm border border-indigo-100 rounded-lg bg-slate-50 text-slate-400 cursor-not-allowed focus:outline-none"
//                                   />
//                                 </div>
//                               </div>
//                             </div>

//                             {/* Preview Calculation */}
//                             {area > 0 && amount > 0 && (
//                               <div className="mt-3 pt-2 border-t border-indigo-100">
//                                 <div className="flex justify-between text-xs">
//                                   <span className="text-slate-500">
//                                     Area: {area.toFixed(2)} m²
//                                   </span>
//                                   <span className="font-semibold text-indigo-600">
//                                     Amount: ₹
//                                     {amount.toLocaleString("en-IN", {
//                                       minimumFractionDigits: 2,
//                                       maximumFractionDigits: 2,
//                                     })}
//                                   </span>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         )}
//                       </div>
//                     );
//                   })}
//                 </div>
//               )}

//               {/* Summary */}
//               {form.mediaRateCardItems.length > 0 && (
//                 <div className="mt-4 pt-3 border-t border-blue-100">
//                   <div className="flex justify-between items-center">
//                     <span className="text-xs text-slate-500">
//                       Selected {form.mediaRateCardItems.length} of{" "}
//                       {rateCards.length} rate cards
//                     </span>
//                     <span className="text-sm font-bold text-indigo-600">
//                       Total: ₹
//                       {calculateTotalAmount().toLocaleString("en-IN", {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       })}
//                     </span>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {/* Actions */}
//         <div className="flex justify-end gap-3">
//           <button
//             onClick={() => {
//               setForm(defaultForm);
//               setCreatedNumber(null);
//               setRateCards([]);
//             }}
//             className="flex items-center gap-1.5 px-6 py-2.5 rounded-xl text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 font-semibold transition"
//           >
//             <RiCloseLine className="w-4 h-4" /> Reset
//           </button>

//           <button
//             onClick={handleSubmit}
//             disabled={submitting}
//             className="flex items-center gap-2 px-7 py-2.5 rounded-xl text-sm font-bold bg-indigo-600 hover:bg-indigo-700 text-white transition shadow-lg shadow-indigo-200 disabled:opacity-60"
//           >
//             {submitting ? <Spinner /> : <RiCheckLine className="w-4 h-4" />}
//             {submitting ? "Creating…" : "Create Quotation"}
//           </button>
//         </div>
//       </div>

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  RiCloseLine,
  RiCheckLine,
  RiErrorWarningLine,
  RiCalendarLine,
  RiFileList3Line,
  RiUserLine,
  RiArrowDownSLine,
  RiMegaphoneLine,
  RiPaletteLine,
  RiUserStarLine,
  RiPriceTag3Line,
  RiRulerLine,
  RiFolderLine,
  RiMoneyDollarCircleLine,
  RiGroupLine,
  RiLockLine,
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const BASE_URL = process.env.REACT_APP_API_URL;

const Spinner = ({ className = "w-4 h-4" }) => (
  <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
);

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div
      className={`fixed top-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
      ${
        type === "success"
          ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
          : "bg-red-50 border border-red-200 text-red-800"
      }`}
    >
      {type === "success" ? (
        <RiCheckLine className="w-4 h-4 text-emerald-500" />
      ) : (
        <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      )}
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-2 opacity-50 hover:opacity-100 transition"
      >
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

const Label = ({ children, required = false }) => (
  <label className="text-[10px] font-semibold text-blue-600 uppercase tracking-widest mb-1 block">
    {children}
    {required && <span className="text-red-500 ml-1">*</span>}
  </label>
);

const inputCls =
  "w-full bg-blue-50/60 border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition";

const selectCls =
  "w-full bg-[#3d2626] border border-[#3d2626] rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-blue-500/30 transition appearance-none cursor-pointer";

const SelectWrapper = ({ children }) => (
  <div className="relative">
    {children}
    <RiArrowDownSLine className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white pointer-events-none" />
  </div>
);

const tomorrow = () => {
  const d = new Date();
  d.setDate(d.getDate());
  return d.toISOString().split("T")[0];
};

const defaultForm = {
  quotationType: "advertising",
  quotationCategory: "",
  personName: "",
  advertisingType: "",
  size: { height: "", width: "" },
  mediaRateCardItems: [],
  brandingPricing: {
    type1Price: "",
    type2Price: "",
    type3Price: "",
    numberOfPersons: "",
  },
  client: "",
  referral: "",
  date: tomorrow(),
};

export default function Quotation() {
  const [form, setForm] = useState(defaultForm);

  const [clients, setClients] = useState([]);
  const [staffMembers, setStaffMembers] = useState([]);
  const [globalAdvTypes, setGlobalAdvTypes] = useState([]);
  const [quotationCategories, setQuotationCategories] = useState([]);
  const [rateCards, setRateCards] = useState([]);
  const [rateCardsLoading, setRateCardsLoading] = useState(false);

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState(null);
  const [createdNumber, setCreatedNumber] = useState(null);

  const notify = (msg, type = "success") => setToast({ message: msg, type });

  // Initial data load
  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const [cR, sR, atR, catR] = await Promise.allSettled([
          axios.get(`${BASE_URL}/bank/get-banks`),
          axios.get(`${BASE_URL}/admin/all-users`),
          axios.get(`${BASE_URL}/quotation-advertising-type`),
          axios.get(`${BASE_URL}/quotation-category`),
        ]);
        if (cR.status === "fulfilled")
          setClients(cR.value?.data?.data || cR.value.data || []);
        if (sR.status === "fulfilled") {
          const allUsers = sR.value?.data?.data || sR.value.data || [];
          // Filter only staff members (userType === "staff")
          const onlyStaff = allUsers.filter(
            (user) => user.userType === "staff",
          );
          setStaffMembers(onlyStaff);
        }
        if (atR.status === "fulfilled")
          setGlobalAdvTypes(atR.value?.data?.data || atR.value.data || []);
        if (catR.status === "fulfilled")
          setQuotationCategories(
            catR.value?.data?.data || catR.value.data || [],
          );
      } catch {
        notify("Some data failed to load", "error");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // Fetch rate cards when advertisingType changes
  useEffect(() => {
    if (!form.advertisingType || form.quotationType !== "advertising") {
      setRateCards([]);
      setField("mediaRateCardItems", []);
      return;
    }

    const fetchRateCards = async () => {
      setRateCardsLoading(true);
      setField("mediaRateCardItems", []);
      try {
        const res = await axios.get(
          `${BASE_URL}/media-rate/by-advertising-type/${form.advertisingType}`,
        );
        setRateCards(res.data?.data || []);
      } catch {
        notify("Failed to load rate cards", "error");
        setRateCards([]);
      } finally {
        setRateCardsLoading(false);
      }
    };

    fetchRateCards();
  }, [form.advertisingType, form.quotationType]);

  // Clear selected items when category changes (switching between combo / normal)
  useEffect(() => {
    setField("mediaRateCardItems", []);
  }, [form.quotationCategory]);

  // Sync global size into all selected mediaRateCardItems whenever size changes
  useEffect(() => {
    if (!form.mediaRateCardItems.length) return;
    const h = parseFloat(form.size.height);
    const w = parseFloat(form.size.width);
    if (!h && !w) return;
    setForm((f) => ({
      ...f,
      mediaRateCardItems: f.mediaRateCardItems.map((item) => ({
        ...item,
        ...(h > 0 ? { height: h } : {}),
        ...(w > 0 ? { width: w } : {}),
      })),
    }));
  }, [form.size.height, form.size.width]);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const setSizeField = (field, value) => {
    setForm((f) => ({
      ...f,
      size: { ...f.size, [field]: value },
    }));
  };

  const setBrandingField = (field, value) => {
    setForm((f) => ({
      ...f,
      brandingPricing: {
        ...f.brandingPricing,
        [field]: value,
      },
    }));
  };

  // ─── Combo helpers ────────────────────────────────────────────────────────────

  /** Returns true when the selected category name contains "combo" (case-insensitive) */
  const isComboCategory = () => {
    if (!form.quotationCategory) return false;
    const selectedCat = quotationCategories.find(
      (cat) => cat._id === form.quotationCategory,
    );
    return selectedCat?.name?.toLowerCase().includes("combo") ?? false;
  };

  /**
   * Filter the fetched rate cards for display:
   *  • Combo category selected  → only show medias whose organisation contains "+"
   *  • Normal / no category     → only show medias whose organisation does NOT contain "+"
   */
  const filteredRateCards = rateCards.filter((rc) => {
    const orgName = rc.media?.organisation ?? "";
    const isComboMedia = orgName.includes("+");
    return isComboCategory() ? isComboMedia : !isComboMedia;
  });

  // ─────────────────────────────────────────────────────────────────────────────

  // Toggle rate card — seeds dimensions from global size fields
  const handleRateCardToggle = (rateCard) => {
    const existingIndex = form.mediaRateCardItems.findIndex(
      (item) => item.mediaRateCard === rateCard._id,
    );

    if (existingIndex !== -1) {
      setField(
        "mediaRateCardItems",
        form.mediaRateCardItems.filter((_, idx) => idx !== existingIndex),
      );
    } else {
      const h = parseFloat(form.size.height) || 1;
      const w = parseFloat(form.size.width) || 1;
      setField("mediaRateCardItems", [
        ...form.mediaRateCardItems,
        {
          mediaRateCard: rateCard._id,
          height: h,
          width: w,
        },
      ]);
    }
  };

  const getRateCardById = (id) => rateCards.find((rc) => rc._id === id);

  const calculatePreview = (height, width, ratePerSquareMeter) => {
    const area = height * width;
    const amount = area * ratePerSquareMeter;
    return { area, amount };
  };

  const isSelected = (rateCardId) =>
    form.mediaRateCardItems.some((item) => item.mediaRateCard === rateCardId);

  const getSelectedItem = (rateCardId) =>
    form.mediaRateCardItems.find((item) => item.mediaRateCard === rateCardId);

  const handleSelectAll = () => {
    if (form.mediaRateCardItems.length === filteredRateCards.length) {
      setField("mediaRateCardItems", []);
    } else {
      const h = parseFloat(form.size.height) || 1;
      const w = parseFloat(form.size.width) || 1;
      const allItems = filteredRateCards.map((rc) => ({
        mediaRateCard: rc._id,
        height: h,
        width: w,
      }));
      setField("mediaRateCardItems", allItems);
    }
  };

  const calculateTotalAmount = () => {
    let total = 0;
    form.mediaRateCardItems.forEach((item) => {
      const rateCard = getRateCardById(item.mediaRateCard);
      if (rateCard) {
        const area = item.height * item.width;
        total += area * rateCard.ratePerSquareMeter;
      }
    });
    return total;
  };

  const calculateBrandingTotal = () => {
    const { type1Price, type2Price, type3Price, numberOfPersons } =
      form.brandingPricing;
    if (type1Price && type2Price && type3Price && numberOfPersons) {
      return (
        (parseFloat(type1Price) +
          parseFloat(type2Price) +
          parseFloat(type3Price)) *
        parseFloat(numberOfPersons)
      );
    }
    return 0;
  };

  const handleSubmit = async () => {
    if (!form.client) return notify("Please select a client", "error");

    if (form.quotationType === "advertising") {
      if (!form.personName.trim())
        return notify(
          "Person name is required for advertising quotation",
          "error",
        );
      if (!form.advertisingType)
        return notify(
          "Advertising type is required for advertising quotation",
          "error",
        );

      const h = parseFloat(form.size.height);
      const w = parseFloat(form.size.width);
      if (!h || h <= 0)
        return notify(
          "Valid height is required for advertising quotation",
          "error",
        );
      if (!w || w <= 0)
        return notify(
          "Valid width is required for advertising quotation",
          "error",
        );

      if (!form.mediaRateCardItems.length)
        return notify(
          "At least one media rate card is required for advertising quotation",
          "error",
        );
    } else if (form.quotationType === "branding") {
      const { type1Price, type2Price, type3Price, numberOfPersons } =
        form.brandingPricing;
      if (!type1Price || parseFloat(type1Price) <= 0)
        return notify(
          "Valid Type 1 price is required for branding quotation",
          "error",
        );
      if (!type2Price || parseFloat(type2Price) <= 0)
        return notify(
          "Valid Type 2 price is required for branding quotation",
          "error",
        );
      if (!type3Price || parseFloat(type3Price) <= 0)
        return notify(
          "Valid Type 3 price is required for branding quotation",
          "error",
        );
      if (!numberOfPersons || parseInt(numberOfPersons) <= 0)
        return notify(
          "Valid number of persons is required for branding quotation",
          "error",
        );
    }

    setSubmitting(true);
    try {
      const payload = {
        quotationType: form.quotationType,
        client: form.client,
        date: form.date,
      };

      if (form.quotationType === "advertising" && form.quotationCategory) {
        payload.quotationCategory = form.quotationCategory;
      }

      if (form.quotationType === "advertising") {
        payload.personName = form.personName;
        payload.advertisingType = form.advertisingType;
        payload.mediaRateCardItems = form.mediaRateCardItems;
      } else if (form.quotationType === "branding") {
        payload.brandingPricing = {
          type1Price: parseFloat(form.brandingPricing.type1Price),
          type2Price: parseFloat(form.brandingPricing.type2Price),
          type3Price: parseFloat(form.brandingPricing.type3Price),
          numberOfPersons: parseInt(form.brandingPricing.numberOfPersons),
        };
      }

      if (form.referral) payload.referral = form.referral;

      const res = await axios.post(`${BASE_URL}/quotation/create`, payload);
      setCreatedNumber(res.data?.data?.quotationNumber || "New");
      notify("Quotation created successfully!");
      setForm(defaultForm);
      setRateCards([]);
    } catch (err) {
      notify(
        err.response?.data?.message || "Failed to create quotation",
        "error",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* Header */}
      <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-indigo-600 flex items-center justify-center text-white shadow-md shadow-indigo-200">
              <RiFileList3Line className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-slate-800 tracking-tight">
                Create Quotation
              </h1>
              <p className="text-[11px] text-blue-400 tracking-widest uppercase">
                New Quotation
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {loading && (
              <span className="flex items-center gap-2 text-xs text-blue-400">
                <Spinner /> Loading…
              </span>
            )}
            {createdNumber && (
              <div className="flex items-center gap-2 px-3 py-1.5 bg-emerald-50 border border-emerald-200 rounded-xl">
                <RiCheckLine className="w-3.5 h-3.5 text-emerald-500" />
                <span className="text-xs font-semibold text-emerald-700">
                  {createdNumber} Created
                </span>
              </div>
            )}
          </div>
        </div>
      </header>

      <div className="px-6 py-6 pb-16 space-y-5 w-full mx-auto">
        {/* Quotation Details */}
        <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
          <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50">
            <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
              Quotation Details
            </span>
          </div>

          <div className="p-5 grid grid-cols-2 gap-5 sm:grid-cols-3">
            {/* Quotation Type */}
            <div className="col-span-2 sm:col-span-1">
              <Label>Quotation Type</Label>
              <div className="flex gap-2">
                {[
                  {
                    value: "advertising",
                    label: "Advertising",
                    Icon: RiMegaphoneLine,
                  },
                  { value: "branding", label: "Branding", Icon: RiPaletteLine },
                ].map(({ value, label, Icon }) => (
                  <button
                    key={value}
                    type="button"
                    onClick={() => {
                      setForm((f) => ({
                        ...f,
                        quotationType: value,
                        quotationCategory: "",
                        size: { height: "", width: "" },
                        ...(value === "branding" && {
                          personName: "",
                          advertisingType: "",
                          mediaRateCardItems: [],
                        }),
                        ...(value === "advertising" && {
                          brandingPricing: {
                            type1Price: "",
                            type2Price: "",
                            type3Price: "",
                            numberOfPersons: "",
                          },
                        }),
                      }));
                      if (value === "branding") setRateCards([]);
                    }}
                    className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition
                      ${
                        form.quotationType === value
                          ? "bg-indigo-600 border-indigo-600 text-white shadow-sm"
                          : "bg-blue-50 border-blue-200 text-blue-500 hover:bg-blue-100"
                      }`}
                  >
                    <Icon className="w-3.5 h-3.5" />
                    {label}
                  </button>
                ))}
              </div>
            </div>

            {/* Quotation Category - Advertising only */}
            {form.quotationType === "advertising" && (
              <div>
                <Label>
                  <RiFolderLine className="inline w-3 h-3 mr-1" />
                  Quotation Category
                </Label>
                <SelectWrapper>
                  <select
                    value={form.quotationCategory}
                    onChange={(e) =>
                      setField("quotationCategory", e.target.value)
                    }
                    className={selectCls}
                  >
                    <option value="">-- Select Category --</option>
                    {quotationCategories.map((cat) => (
                      <option key={cat._id} value={cat._id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </SelectWrapper>
              </div>
            )}

            {/* Client */}
            <div>
              <Label required>Client</Label>
              <SelectWrapper>
                <select
                  value={form.client}
                  onChange={(e) => setField("client", e.target.value)}
                  className={selectCls}
                >
                  <option value="">-- Select Client --</option>
                  {clients.map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.bankName || c.name}
                    </option>
                  ))}
                </select>
              </SelectWrapper>
            </div>

            {/* Date */}
            <div>
              <Label>Date</Label>
              <div className="relative">
                <RiCalendarLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
                <input
                  type="date"
                  value={form.date}
                  onChange={(e) => setField("date", e.target.value)}
                  className={`${inputCls} pl-9`}
                />
              </div>
            </div>

            {/* Person Name - Advertising only */}
            {form.quotationType === "advertising" && (
              <div>
                <Label required>Person Name</Label>
                <div className="relative">
                  <RiUserLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
                  <input
                    type="text"
                    value={form.personName}
                    onChange={(e) => setField("personName", e.target.value)}
                    placeholder="Enter person name"
                    className={`${inputCls} pl-9`}
                  />
                </div>
              </div>
            )}

            {/* Advertising Type - Advertising only */}
            {form.quotationType === "advertising" && (
              <div>
                <Label required>
                  <RiPriceTag3Line className="inline w-3 h-3 mr-1" />
                  Advertising Type
                </Label>
                <SelectWrapper>
                  <select
                    value={form.advertisingType}
                    onChange={(e) =>
                      setField("advertisingType", e.target.value)
                    }
                    className={selectCls}
                  >
                    <option value="">-- Select Type --</option>
                    {globalAdvTypes.map((at) => (
                      <option key={at._id} value={at._id}>
                        {at.name}
                      </option>
                    ))}
                  </select>
                </SelectWrapper>
              </div>
            )}

            {/* Global Size Fields - Advertising only */}
            {form.quotationType === "advertising" && (
              <>
                <div>
                  <Label required>
                    <RiRulerLine className="inline w-3 h-3 mr-1" />
                    Height (m)
                  </Label>
                  <div className="relative">
                    <RiRulerLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
                    <input
                      type="number"
                      step="0.01"
                      min="0.01"
                      value={form.size.height}
                      onChange={(e) => setSizeField("height", e.target.value)}
                      placeholder="Enter height in meters"
                      className={`${inputCls} pl-9`}
                    />
                  </div>
                  <p className="text-xs text-slate-400 mt-1">
                    Applied to all rate cards
                  </p>
                </div>

                <div>
                  <Label required>
                    <RiRulerLine className="inline w-3 h-3 mr-1" />
                    Width (m)
                  </Label>
                  <div className="relative">
                    <RiRulerLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300" />
                    <input
                      type="number"
                      step="0.01"
                      min="0.01"
                      value={form.size.width}
                      onChange={(e) => setSizeField("width", e.target.value)}
                      placeholder="Enter width in meters"
                      className={`${inputCls} pl-9`}
                    />
                  </div>
                  <p className="text-xs text-slate-400 mt-1">
                    Applied to all rate cards
                  </p>
                </div>
              </>
            )}

            {/* Referral - Changed from Agent to Staff */}
            <div>
              <Label>
                <RiUserStarLine className="inline w-3 h-3 mr-1" />
                Referral (Staff)
              </Label>
              <SelectWrapper>
                <select
                  value={form.referral}
                  onChange={(e) => setField("referral", e.target.value)}
                  className={selectCls}
                >
                  <option value="">-- Select Staff --</option>
                  {staffMembers.map((staff) => (
                    <option key={staff._id} value={staff._id}>
                      {staff.name} {staff.position && `- ${staff.position}`}
                    </option>
                  ))}
                </select>
              </SelectWrapper>
            </div>
          </div>
        </div>

        {/* Branding Pricing Section */}
        {form.quotationType === "branding" && (
          <div className="bg-white border border-purple-100 rounded-2xl shadow-sm overflow-hidden">
            <div className="px-5 py-3 border-b border-purple-50 bg-purple-50/50">
              <span className="text-xs font-semibold text-purple-700 uppercase tracking-widest">
                Branding Pricing Details
              </span>
            </div>

            <div className="p-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <Label required>
                    <RiMoneyDollarCircleLine className="inline w-3 h-3 mr-1" />
                    Type 1 Price (₹)
                  </Label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={form.brandingPricing.type1Price}
                    onChange={(e) =>
                      setBrandingField("type1Price", e.target.value)
                    }
                    placeholder="Enter Type 1 price"
                    className={inputCls}
                  />
                  <p className="text-xs text-slate-400 mt-1">
                    Base price for Type 1 branding
                  </p>
                </div>

                <div>
                  <Label required>
                    <RiMoneyDollarCircleLine className="inline w-3 h-3 mr-1" />
                    Type 2 Price (₹)
                  </Label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={form.brandingPricing.type2Price}
                    onChange={(e) =>
                      setBrandingField("type2Price", e.target.value)
                    }
                    placeholder="Enter Type 2 price"
                    className={inputCls}
                  />
                  <p className="text-xs text-slate-400 mt-1">
                    Base price for Type 2 branding
                  </p>
                </div>

                <div>
                  <Label required>
                    <RiMoneyDollarCircleLine className="inline w-3 h-3 mr-1" />
                    Type 3 Price (₹)
                  </Label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={form.brandingPricing.type3Price}
                    onChange={(e) =>
                      setBrandingField("type3Price", e.target.value)
                    }
                    placeholder="Enter Type 3 price"
                    className={inputCls}
                  />
                  <p className="text-xs text-slate-400 mt-1">
                    Base price for Type 3 branding
                  </p>
                </div>

                <div>
                  <Label required>
                    <RiGroupLine className="inline w-3 h-3 mr-1" />
                    Number of Persons
                  </Label>
                  <input
                    type="number"
                    step="1"
                    min="1"
                    value={form.brandingPricing.numberOfPersons}
                    onChange={(e) =>
                      setBrandingField("numberOfPersons", e.target.value)
                    }
                    placeholder="Enter number of persons"
                    className={inputCls}
                  />
                  <p className="text-xs text-slate-400 mt-1">
                    Total number of persons for branding
                  </p>
                </div>
              </div>

              {calculateBrandingTotal() > 0 && (
                <div className="mt-5 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl border border-purple-100">
                  <div className="flex justify-between items-center">
                    <div>
                      <span className="text-xs font-semibold text-purple-600 uppercase tracking-wider">
                        Total Amount Preview
                      </span>
                      <p className="text-xs text-slate-500 mt-1">
                        ({form.brandingPricing.type1Price} +{" "}
                        {form.brandingPricing.type2Price} +{" "}
                        {form.brandingPricing.type3Price}) ×{" "}
                        {form.brandingPricing.numberOfPersons}
                      </p>
                    </div>
                    <span className="text-2xl font-bold text-purple-600">
                      ₹
                      {calculateBrandingTotal().toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Media Rate Cards Section - Advertising only */}
        {form.quotationType === "advertising" && form.advertisingType && (
          <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
            <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                  Media Rate Cards
                </span>
                {/* Combo mode badge */}
                {isComboCategory() && (
                  <span className="px-2 py-0.5 bg-orange-50 border border-orange-200 rounded-full text-[10px] font-semibold text-orange-600">
                    Combo Medias
                  </span>
                )}
                {/* Live size badge */}
                {(form.size.height || form.size.width) && (
                  <span className="flex items-center gap-1 px-2 py-0.5 bg-indigo-50 border border-indigo-200 rounded-full text-[10px] font-semibold text-indigo-600">
                    <RiRulerLine className="w-3 h-3" />
                    {form.size.height || "–"} × {form.size.width || "–"} m
                  </span>
                )}
              </div>
              {filteredRateCards.length > 0 && (
                <button
                  onClick={handleSelectAll}
                  className="text-xs font-medium text-indigo-600 hover:text-indigo-700 px-3 py-1 rounded-lg hover:bg-indigo-50 transition"
                >
                  {form.mediaRateCardItems.length === filteredRateCards.length
                    ? "Deselect All"
                    : "Select All"}
                </button>
              )}
            </div>

            <div className="p-5">
              {/* Hint when size not filled */}
              {(!form.size.height || !form.size.width) && (
                <div className="mb-4 flex items-center gap-2 px-4 py-2.5 bg-amber-50 border border-amber-200 rounded-xl text-xs text-amber-700 font-medium">
                  <RiRulerLine className="w-4 h-4 flex-shrink-0" />
                  Enter Height &amp; Width above — dimensions will auto-fill for
                  all rate cards.
                </div>
              )}

              {rateCardsLoading ? (
                <div className="flex items-center justify-center py-8">
                  <Spinner className="w-6 h-6 text-blue-400" />
                  <span className="ml-2 text-sm text-blue-500">
                    Loading rate cards...
                  </span>
                </div>
              ) : filteredRateCards.length === 0 ? (
                <div className="text-center py-8 text-slate-400 text-sm">
                  {rateCards.length > 0
                    ? `No ${isComboCategory() ? "combo" : "regular"} media rate cards available for this advertising type`
                    : "No rate cards available for this advertising type"}
                </div>
              ) : (
                <div className="space-y-4 max-h-96 overflow-y-auto pr-2">
                  {filteredRateCards.map((rc) => {
                    const selected = isSelected(rc._id);
                    const selectedItem = getSelectedItem(rc._id);
                    const { area, amount } =
                      selected && selectedItem
                        ? calculatePreview(
                            selectedItem.height,
                            selectedItem.width,
                            rc.ratePerSquareMeter,
                          )
                        : { area: 0, amount: 0 };

                    return (
                      <div
                        key={rc._id}
                        className={`border rounded-lg transition ${
                          selected
                            ? "border-indigo-300 bg-indigo-50/30"
                            : "border-blue-100 hover:bg-blue-50/50"
                        }`}
                      >
                        {/* Rate Card Header */}
                        <div className="p-3">
                          <label className="flex items-start gap-3 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={selected}
                              onChange={() => handleRateCardToggle(rc)}
                              className="mt-0.5 w-4 h-4 text-indigo-600 rounded border-blue-300 focus:ring-indigo-500"
                            />
                            <div className="flex-1">
                              <div className="flex items-center gap-2 mb-1">
                                <span className="font-semibold text-sm text-slate-800">
                                  {rc.media?.organisation ?? "Unknown Media"}
                                </span>
                                <span className="text-xs text-blue-500 bg-blue-100 px-2 py-0.5 rounded">
                                  {rc.edition}
                                </span>
                                <span className="text-xs font-mono text-slate-500">
                                  Rate: ₹
                                  {rc.ratePerSquareMeter?.toLocaleString(
                                    "en-IN",
                                  )}
                                  /sqm
                                </span>
                              </div>
                              {rc.description && (
                                <p className="text-xs text-slate-400 mt-1">
                                  {rc.description}
                                </p>
                              )}
                            </div>
                          </label>
                        </div>

                        {/* Read-only dimension display (shown only when selected) */}
                        {selected && selectedItem && (
                          <div className="px-3 pb-3 pt-0 border-t border-indigo-100 mt-2">
                            <div className="grid grid-cols-2 gap-3 pt-3">
                              {/* Height - read only */}
                              <div>
                                <label className="text-[10px] font-semibold text-indigo-600 uppercase tracking-wider flex items-center gap-1">
                                  Height (m)
                                  <RiLockLine className="w-3 h-3 text-indigo-400" />
                                </label>
                                <div className="relative mt-1">
                                  <RiRulerLine className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-indigo-300" />
                                  <input
                                    type="number"
                                    readOnly
                                    tabIndex={-1}
                                    value={selectedItem.height}
                                    className="w-full pl-8 pr-3 py-1.5 text-sm border border-indigo-100 rounded-lg bg-slate-50 text-slate-400 cursor-not-allowed focus:outline-none"
                                  />
                                </div>
                              </div>
                              {/* Width - read only */}
                              <div>
                                <label className="text-[10px] font-semibold text-indigo-600 uppercase tracking-wider flex items-center gap-1">
                                  Width (m)
                                  <RiLockLine className="w-3 h-3 text-indigo-400" />
                                </label>
                                <div className="relative mt-1">
                                  <RiRulerLine className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-indigo-300" />
                                  <input
                                    type="number"
                                    readOnly
                                    tabIndex={-1}
                                    value={selectedItem.width}
                                    className="w-full pl-8 pr-3 py-1.5 text-sm border border-indigo-100 rounded-lg bg-slate-50 text-slate-400 cursor-not-allowed focus:outline-none"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Preview Calculation */}
                            {area > 0 && amount > 0 && (
                              <div className="mt-3 pt-2 border-t border-indigo-100">
                                <div className="flex justify-between text-xs">
                                  <span className="text-slate-500">
                                    Area: {area.toFixed(2)} m²
                                  </span>
                                  <span className="font-semibold text-indigo-600">
                                    Amount: ₹
                                    {amount.toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* Summary */}
              {form.mediaRateCardItems.length > 0 && (
                <div className="mt-4 pt-3 border-t border-blue-100">
                  <div className="flex justify-between items-center">
                    <span className="text-xs text-slate-500">
                      Selected {form.mediaRateCardItems.length} of{" "}
                      {filteredRateCards.length} rate cards
                    </span>
                    <span className="text-sm font-bold text-indigo-600">
                      Total: ₹
                      {calculateTotalAmount().toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="flex justify-end gap-3">
          <button
            onClick={() => {
              setForm(defaultForm);
              setCreatedNumber(null);
              setRateCards([]);
            }}
            className="flex items-center gap-1.5 px-6 py-2.5 rounded-xl text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 font-semibold transition"
          >
            <RiCloseLine className="w-4 h-4" /> Reset
          </button>

          <button
            onClick={handleSubmit}
            disabled={submitting}
            className="flex items-center gap-2 px-7 py-2.5 rounded-xl text-sm font-bold bg-indigo-600 hover:bg-indigo-700 text-white transition shadow-lg shadow-indigo-200 disabled:opacity-60"
          >
            {submitting ? <Spinner /> : <RiCheckLine className="w-4 h-4" />}
            {submitting ? "Creating…" : "Create Quotation"}
          </button>
        </div>
      </div>

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
}
